<template>
  <div :id="id">
    <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '','content-header px-sm-0 px-2']">
      <div :class="['main-center-title d-flex', (lang === 'ar' && type === 'service-center' ? 'bold-ar right-dir': type === 'service-center' ? 'bold-en' : ''), (type !== 'faq' ? 'list-style' : ''), (type === 'faq' && this.$lang === 'ar' ? 'regular-italic-ar flex-row-reverse' : type === 'faq' ? 'regular-italic-en' : '')]">
        <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex']" v-if="type === 'faq'"> <div>{{index + 1 }}</div> <div class="px-1"> - </div>  </div>
        <div :class="this.$lang === 'ar' && 'right-dir'">
          <span v-if="type === 'faq'">{{data.title}} </span>
          <span v-if="type === 'service-center'"> <span :class="[this.$lang === 'ar' ? 'right-bullet' :'left-bullet', 'title-bullet']"></span>{{data.address}}</span>
        </div>
      </div>
      <div @click="showUp" class="more"> <span v-if="!show">+</span> <span v-if="show">-</span> </div>
    </div>
    <div v-if="type === 'service-center'" :class="[lang === 'ar' ? 'right-align' : 'left-align' ,'extra-info px-sm-2 px-4']">
      <div class="wrapper">
        <div class="inner">
<!--          <div class="info-container">-->
<!--            <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en' ,'info-header']"> {{$t('serviceCenter.address')}} </div>-->
<!--            <div :class="[lang === 'ar' ? 'regular-ar' : '','info-content']"> {{data.address}} </div>-->
<!--          </div>-->
          <div class="info-container">
            <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en' ,'info-header']"> {{$t('serviceCenter.centerWorkHours')}} </div>
            <div v-for="(item, index) in data.info" :key="index" class="info-content pb-2">
              <div :class="[lang === 'ar' ? 'right-dir medium-italic-ar' : 'medium-italic-en', 'info-content-title list-style']">
                <div class="bullet"></div> {{item.title}}
              </div>
              <div style="white-space: break-spaces" :class="[lang === 'ar' ? 'regular-ar' : 'regular-en' ,'info-content-desc px-2']">
                {{ item.desc }}
              </div>
            </div>
          </div>
          <div class="info-container">
            <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en' ,'info-header']" style="color: #FF4E3E"> {{$t('serviceCenter.workDays')}} </div>
            <div :class="[lang === 'ar' ? 'regular-ar' : '','info-content']">
              {{data.days}}
            </div>
          </div>
          <div class="info-container">
            <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en' ,'info-header smaller-font text-decoration-underline']">
              <a target="_blank" :href="'https://www.google.com/maps/search/?api=1&query= '+ data.lat + ',' + data.long ">{{$t('serviceCenter.map')}} </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type === 'faq'" class="">
      <div class="wrapper">
        <div  style="white-space: break-spaces" :class="[this.$lang === 'ar' ? 'right-align regular-ar right-dir' : 'left-align regular-en left-dir', 'info-desc inner mb-2']">{{data.desc}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  data () {
    return {
      lang: this.$lang,
      show: false,
      id: `item-${this.index}`
    }
  },
  props: {
    data: Object,
    type: String,
    index: Number,
    tabChange: Number
  },
  watch: {
    tabChange () {
      this.show = false
      $('.wrapper').removeClass('is-open')
    }
  },
  created () {
    this.$watch(() => {
      return this.$store.state.supportSectionTabs
    }, val => {
      this.show = false
      $('.wrapper').removeClass('is-open')
    })
  },
  methods: {
    showUp () {
      this.show = !this.show
      if (this.show) {
        if (this.type === 'service-center') {
          $(`#${this.id} .wrapper`).addClass('is-open')
        } else {
          $(`#${this.id} .wrapper`).addClass('is-open')
        }
      } else {
        if (this.type === 'service-center') {
          $(`#${this.id} .wrapper`).removeClass('is-open')
        } else {
          $(`#${this.id} .wrapper`).removeClass('is-open')
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "src/assets/sass/main.sass";
.title-bullet{
  height: 5px;
  width: 5px;
  background: #FFCB05;
  display: inline-block;
  border-radius: 50%;
  margin: 0 4px 2px 4px;
}
.left-bullet{
  margin: 0 4px 2px 0px;
}
.right-bullet{
  margin: 0 0px 2px 4px;
}
.bullet{
  height: 3.5px;
  width: 3.5px;
  background: #1d1d1d;
  display: inline-block;
  border-radius: 50%;
  margin-bottom: 2px;
  margin: 0 5px 2px 0px;
  margin: 0 5px 2px 0px;
}
.content-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px; // 85px in design
  //cursor: pointer;
  position: relative;
  text-align: initial
}
.main-center-title{
  color: $--yellow;
  font-size: 16px;
}
.more{
  font-size: 20px;
  cursor: pointer;
}
.list-style{
  display: list-item;
}
.info-container{
  padding: 10px 0;
}
.info-header{
  font-size: 14px;
  color: #1d1d1d;
}
.info-content{
  font-size: 12px;
}
.extra-info{
  //height: 0px;
  overflow: hidden;
  transition: all .4s ease-out;
}
.info-content-desc{
  color: #6A6A6A;
}
.info-desc{
  font-size: 13px;
}
.status{
  font-size: 12px;
  color: $--red;
  position: absolute;
  top: 40px;
}
.smaller-font{
  font-size: 12px;
}
.wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows .2s ease-out;
}

.wrapper.is-open {
  grid-template-rows: 1fr;
}

.inner {
  overflow: hidden;
}
</style>
